// Convert axios error / FastAPI Pydantic 422 detail into a readable string
export function formatApiError(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (!detail && err?.response?.data) {
    // Some endpoints return data as array of errors
    const d = err.response.data;
    if (Array.isArray(d)) return d.map((e) => e?.msg || String(e)).join(", ");
    if (typeof d === "string") return d;
  }
  if (Array.isArray(detail)) {
    // Pydantic v2 validation errors: [{loc, msg, type}, ...]
    return detail
      .map((e) => {
        const field = Array.isArray(e?.loc) ? e.loc.filter((x) => x !== "body").join(".") : "";
        const msg = e?.msg || "Invalid value";
        return field ? `${field}: ${msg}` : msg;
      })
      .join("; ");
  }
  if (typeof detail === "string") return detail;
  if (detail && typeof detail === "object") return detail.msg || JSON.stringify(detail);
  if (err?.message) return err.message;
  return fallback;
}
